export default __webpack_public_path__ + "static/media/tea-hel.421ad83f.jpg";